import script from "./GameScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameScreen.vue?vue&type=script&setup=true&lang=ts"

import "./GameScreen.vue?vue&type=style&index=0&id=ac39df96&scoped=true&lang=css"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac39df96"]])

export default __exports__